import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  getCreditBreakdown,
  getTravelCreditsHistoryTransaction,
  getTravelWalletCredit,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { getRewardsAccounts } from "../../../rewards/reducer";
import { ExperiencesTravelCreditBalanceCard } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  credit: getTravelWalletCredit(state),
  creditBreakdown: getCreditBreakdown(state),
  creditsTransactionHistory: getTravelCreditsHistoryTransaction(state),
  rewardsAccounts: getRewardsAccounts(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ExperiencesTravelCreditBalanceCardConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedExperiencesTravelCreditBalanceCard = connector(
  withRouter(ExperiencesTravelCreditBalanceCard)
);
